import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useFamily } from '../context/FamilyContext';
import SetupWizard from '../components/onboarding/SetupWizard';

const OnboardingPage = () => {
  const { hasFamily, loading } = useFamily();

  // Latch whether the user already belonged to a family the moment onboarding
  // first settled. SetupWizard creates the family in step 1, which flips
  // `hasFamily` to true via the live user-doc subscription. Without this latch
  // the page would re-render and unmount the wizard the instant the family is
  // created — stranding the user on "You're already in a family!" before they
  // can add a child, set a schedule, or reach step 4 to see/share their invite
  // code. By capturing the entry value once loading completes, the wizard stays
  // mounted through all four steps even as `hasFamily` becomes true.
  const entryHadFamily = useRef(null);
  if (!loading && entryHadFamily.current === null) {
    entryHadFamily.current = hasFamily;
  }

  // Wait for the family state to resolve before deciding what to render, so we
  // never briefly show the wizard to someone who already has a family.
  if (entryHadFamily.current === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-50">
        <div className="w-8 h-8 border-4 border-canopy border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (entryHadFamily.current) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-50 px-4">
        <div className="text-center animate-fade-in">
          <h2 className="text-2xl font-bold text-ink-900 tracking-tight mb-4">You're already in a family!</h2>
          <Link to="/dashboard" className="btn-primary px-8">
            Go to Dashboard
          </Link>
        </div>
      </div>
    );
  }

  return <SetupWizard />;
};

export default OnboardingPage;
